import { isDefined } from './utils';

// Describes single 'placeholder' found in the raw text
// those 'placeholders' will be extracted from raw text for further
// conversion into Deltas
interface PlaceholderPosition {
    start: number;
    length: number;
    value: string;
}

// Represents a smallest piece extracted from text (text or placeholder)
// for further conversion into a set of Delta's insert operations to build
// Delta tree to init Quill with
interface InsertChunk {
    value: string;
    type: 'text' | 'placeholder';
}

export function createChunksFromString(
    value: string,
    placeholderRegexps: RegExp[],
): InsertChunk[] {
    const placeholderPositions: PlaceholderPosition[] = [];

    // find occurrences of supported placeholders in the raw template tag
    placeholderRegexps.forEach((re) => {
        re.lastIndex = 0;

        let execArray;
        while ((execArray = re.exec(value)) !== null) {
            placeholderPositions.push({
                start: execArray.index,
                length: execArray[0].length,
                value: execArray[0],
            });
        }
    });
    placeholderPositions.sort((p1, p2) => p1.start - p2.start);

    // convert raw text into a set of chunks to be later mapped into Delta's nodes
    const chunks: InsertChunk[] = [];
    let charIndex = 0;
    placeholderPositions.forEach((placeholderPos) => {
        const endPos = placeholderPos.start;
        if (charIndex < endPos) {
            chunks.push({
                value: value.substr(charIndex, endPos - charIndex),
                type: 'text',
            });
        }

        chunks.push({
            value: placeholderPos.value,
            type: 'placeholder',
        });

        charIndex = placeholderPos.start + placeholderPos.length;
    });

    if (charIndex < value.length) {
        chunks.push({ value: value.substr(charIndex), type: 'text' });
    }

    return chunks;
}

// If the url provided does not start with any of whitelisted protocols it will be
// treated as a relative one. This prevents default behavior.
export function customizeLinkBlot(Link: any) {
    class CustomLink extends Link {
        static sanitize(url) {
            const value = super.sanitize(url);
            const startsWithWhitelistedPrefix =
                isDefined(value) &&
                this.PROTOCOL_WHITELIST.some((prefix) =>
                    value.startsWith(prefix),
                );

            return startsWithWhitelistedPrefix ? value : `https://${value}`;
        }
    }

    return CustomLink;
}
